module.exports = __webpack_public_path__ + "img/imgDefault.e2e95292.png";